// CityCenters.js
import React, {useState} from 'react';
import './CityCenters.scss';
import {formatActivityHours} from '../../IdfSaleEnums';

const CityCenters = (props) => {
  const {serviceCenters, isVisible, selectedCenter, handleSelect} = props;
  // const [selectedCenter, setSelectedCenter] = useState(null);

  // const handleSelect = (center) => {
  //   setSelectedCenter(center === selectedCenter ? null : center);
  // };

  if (!isVisible) {
    return null;
  }

  return (
    <div className='centers-container'>
      {serviceCenters.map((center, index) => (
        <div key={index} className={`service-center ${center === selectedCenter ? 'selected' : ''}`} onClick={() => handleSelect(center)}>
          <div className='checkmark-container'>
            <div className='checkmark-circle'></div>
            {center === selectedCenter && <div className='checkmark'></div>}
          </div>
          <div className='center-details'>
            <div className='center-name'>{center.service_center_name}</div>
            <div className='center-location'>{center.service_center_location}</div>
            <div className='center-activity-hours'>{formatActivityHours(center.activity_hours)}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CityCenters;
